import { createAction } from 'redux-actions';
export var SET_FARE_FAMILY = 'SET_FARE_FAMILY';
export var setFareFamily = createAction(SET_FARE_FAMILY, function (fareFamily) { return fareFamily; });
